// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    width: 100%;
    max-width: 600px;
    margin: 50px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    height: 80vh;
    overflow-y: scroll;
}

.profile-container img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin: 20px auto;
    display: block;
    border: 4px solid var(--main-color);
}

.profile-container h1 {
    text-align: center;
    font-size: 24px;
    color: #333;
    margin-top: 10px;
}

.profile-container p {
    text-align: center;
    font-size: 16px;
    color: #666;
    margin: 5px 0;
    overflow: hidden;
}

.profile-container .info-section {
    margin-top: 20px;
    padding: 10px 15px;
    border-top: 1px solid #ddd;
}

.profile-container .acc-tkn{
    font-size: 13px;
}

.profile-container .acc-menu{
    display: flex;
    justify-content: center;
    position: relative;

}
.profile-container .acc-menu button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin-left: 6px;
}

.profile-container .acc-menu .acc-dropdown{
    position: absolute;
    top: 100%;
    background-color: white;
    box-shadow: 1px 1px 1px #EEE;
    padding: 4px 6px;
    border-radius: 7px;
    border: 1px solid #EEE;
    transform: translateY(-50px);
    visibility:hidden ;
    transition: var(--main-transition);
    opacity: 0;
    height: 260px;
    overflow-y: scroll;
}

.profile-container .acc-menu .active-drop{
visibility: visible;
opacity: 1
;
transform: translateY(0px);
}

.profile-container .acc-menu .acc-dropdown .tab{
    display: flex;
    align-items: center;
    width: 270px;
    padding: 3px ;
    max-width: 100%;
    justify-content: space-between;
    transition: var(--main-transition);

}

.profile-container .acc-menu .acc-dropdown .active{
    background-color: #EEE;

}

.profile-container .acc-menu .acc-dropdown .tab:hover{
    background-color: #EEE;
}

.profile-container .acc-menu .acc-dropdown .tab p{
    width: 235px;
    font-size: 15px;
    cursor: pointer;
}

.profile-container .acc-menu .acc-dropdown .tab .del-btn {
    color: #dc3545;
    transition: var(--main-transition);
    cursor: pointer;
    font-size: 14px;
    padding: 5px;
    width: 25px ;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 25px;
}

.profile-container .info-section h2 {
    font-size: 20px;
    color: #444;
    margin-bottom: 10px;
}

.profile-container .info-section .status {
    font-size: 18px;
    color: green;
    margin-bottom: 10px;
}
.profile-container .info-section p {
    font-size: 16px;
    color: #555;
    margin-bottom: 8px;
}

.profile-container .edit-profile-btn {
    display: block;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: var(--main-color);
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.profile-container .edit-profile-btn:hover {
    background-color: var(--main-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Profile/profile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;;AAEtB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;AACA,mBAAmB;AACnB;AACA;AACA,0BAA0B;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kCAAkC;;AAEtC;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":[".profile-container {\n    width: 100%;\n    max-width: 600px;\n    margin: 50px auto;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    height: 80vh;\n    overflow-y: scroll;\n}\n\n.profile-container img {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    margin: 20px auto;\n    display: block;\n    border: 4px solid var(--main-color);\n}\n\n.profile-container h1 {\n    text-align: center;\n    font-size: 24px;\n    color: #333;\n    margin-top: 10px;\n}\n\n.profile-container p {\n    text-align: center;\n    font-size: 16px;\n    color: #666;\n    margin: 5px 0;\n    overflow: hidden;\n}\n\n.profile-container .info-section {\n    margin-top: 20px;\n    padding: 10px 15px;\n    border-top: 1px solid #ddd;\n}\n\n.profile-container .acc-tkn{\n    font-size: 13px;\n}\n\n.profile-container .acc-menu{\n    display: flex;\n    justify-content: center;\n    position: relative;\n\n}\n.profile-container .acc-menu button{\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    margin-left: 6px;\n}\n\n.profile-container .acc-menu .acc-dropdown{\n    position: absolute;\n    top: 100%;\n    background-color: white;\n    box-shadow: 1px 1px 1px #EEE;\n    padding: 4px 6px;\n    border-radius: 7px;\n    border: 1px solid #EEE;\n    transform: translateY(-50px);\n    visibility:hidden ;\n    transition: var(--main-transition);\n    opacity: 0;\n    height: 260px;\n    overflow-y: scroll;\n}\n\n.profile-container .acc-menu .active-drop{\nvisibility: visible;\nopacity: 1\n;\ntransform: translateY(0px);\n}\n\n.profile-container .acc-menu .acc-dropdown .tab{\n    display: flex;\n    align-items: center;\n    width: 270px;\n    padding: 3px ;\n    max-width: 100%;\n    justify-content: space-between;\n    transition: var(--main-transition);\n\n}\n\n.profile-container .acc-menu .acc-dropdown .active{\n    background-color: #EEE;\n\n}\n\n.profile-container .acc-menu .acc-dropdown .tab:hover{\n    background-color: #EEE;\n}\n\n.profile-container .acc-menu .acc-dropdown .tab p{\n    width: 235px;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n.profile-container .acc-menu .acc-dropdown .tab .del-btn {\n    color: #dc3545;\n    transition: var(--main-transition);\n    cursor: pointer;\n    font-size: 14px;\n    padding: 5px;\n    width: 25px ;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 25px;\n}\n\n.profile-container .info-section h2 {\n    font-size: 20px;\n    color: #444;\n    margin-bottom: 10px;\n}\n\n.profile-container .info-section .status {\n    font-size: 18px;\n    color: green;\n    margin-bottom: 10px;\n}\n.profile-container .info-section p {\n    font-size: 16px;\n    color: #555;\n    margin-bottom: 8px;\n}\n\n.profile-container .edit-profile-btn {\n    display: block;\n    margin: 20px auto;\n    padding: 10px 20px;\n    background-color: var(--main-color);\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.profile-container .edit-profile-btn:hover {\n    background-color: var(--main-color-dark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
